module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/fix_chat_man.0d864172.png";